import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7n4zs8cxj: FaireProductEntity = {
  token: "p_m7n4zs8cxj",
  type: "product",
  name: "Fine Organic Cotton Neckscarf",
  brandToken: "b_54be1bc9",
  brandName: "SCARFSHOP",
  imageUrl:
    "https://cdn.faire.com/fastly/b0fcdb27eb1041f9e34437450e5f83e41c09df6dd7515e172bdcc786961eff29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81ca42db31bd6e67267dbb3dcac6606e6afd67de4aa2473e91945cfe8b05bca1.jpeg",
    "https://cdn.faire.com/fastly/bd79477de539c9781d9c19acbe778e058525a2e9255679a59f31266cab053396.jpeg",
    "https://cdn.faire.com/fastly/12e6062554b0f2e6d07a1d8a9973bb471d122b259e5ea1eb06d2cd01a6157398.jpeg",
    "https://cdn.faire.com/fastly/80f2a8cf8e379ae9c3cb08150867e6e9e4bb8cd6fcd3bfcbcbde9b29bec8e4c9.jpeg",
    "https://cdn.faire.com/fastly/46ac95f75b2050d1485ae2b30ab95b9b63cd76cd0dcbb089f7e301cd36fb69e3.jpeg",
    "https://cdn.faire.com/fastly/9d56f15dbf4309f8053cf52e046825a6be656353ac8b77b20662133c2115196b.jpeg",
    "https://cdn.faire.com/fastly/20c0dac9ea433f5a890a7cd136fb07c58c55c62178cfe3a84ef1a61ec2a2556a.jpeg",
    "https://cdn.faire.com/fastly/497883e60eb73c5be2483d73888bb20b0e41aaeb9ba97047846e77b43330d312.jpeg",
    "https://cdn.faire.com/fastly/316c7ce0c277bf2990e3ba1c64df041773722ebadcd6d490512a78393dc33f97.jpeg",
    "https://cdn.faire.com/fastly/d0dc0a947ebdedc6aaa9405d0ac1807293d3567365735ad78f7eb2473bdb73b1.jpeg",
    "https://cdn.faire.com/fastly/d9893bc5183a31ce95403feaefbf5f7fa74c4183755a4a0e90ff176a8e2cc654.jpeg",
    "https://cdn.faire.com/fastly/929e07569ba5533af3d7658127e0829a2b86abf5e0720c53e34e875c2f2c2323.jpeg",
    "https://cdn.faire.com/fastly/a27e402601c5ecec83b744f7ee55561905be51116113a125035ad7a60d3ed434.jpeg",
  ],
  priceDollars: 22,
  description:
    '*Please note that while we maintain a small amount of stock, most of our products are made to order and may take up to 2 weeks to ship, although most ship in just a few days. Please contact us if you have a time sensitive order.\n\nA fine weave of organic cotton threads creates a soft, translucent scarf with body and slight texture. A denser weave than the regular cotton, but still light and airy. Now in a smaller size, perfect as an accent, tucking under a jacket, in your hair, or tied on to a bag.\n\n100% hand dyed organic cotton* with hemmed edges\nThis is a zero waste product\nOne size: aprox. 26" x 26"\nAvailable in 32 colors. See color sheet for options - scroll down to last image.',
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:45.807Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
